import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-section-header-description',
  templateUrl: './page-section-header-description.component.html',
  styleUrl: './page-section-header-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageSectionHeaderDescriptionComponent {}
